import React from 'react'
import '../../styles/_Skills.css'
import { Grid, Row, Col } from 'react-bootstrap'
import SideBar from '../SideBar'
import MenuSK from './Menu_sk'
import Professional from './Badge'
import Code from './Tech'
import { connect } from 'redux-zero/react'

const Skills = ({bio, isSpanish}) => {
  return (
    <Col className='skills__container--content'>
      <Professional bio={bio} isSpanish={isSpanish} />
      <Code bio={bio} isSpanish={isSpanish} />
    </Col>
  )
}

const SkillsContainer = ({bio, isSpanish}) => {
  return (
    <Col lg={9} md={9} id='skills__container'>
      <MenuSK isSpanish={isSpanish} />
      <Skills bio={bio} isSpanish={isSpanish} />
    </Col>
  )
}

const SkillsView = ({bio, isSpanish}) => {
  return (
    <Grid fluid>
      <Row>
        <SideBar />
        <SkillsContainer bio={bio} isSpanish={isSpanish} />
      </Row>
    </Grid>
  )
}

// export default SkillsView;  className='skills__container--content'
const mapToProps = ({ bio, isSpanish }) => ({ bio, isSpanish })
export default connect(mapToProps)(SkillsView)



// WEBPACK FOOTER //
// ./src/components/Skills/Skills.js